import { 
  ScreenerPageConfig, 
  BASE_CONFIG, 
  SCREENER_VARIANTS, 
  createTabs, 
  createRankingSection 
} from './shared-screener-config';

const variant = SCREENER_VARIANTS.quality;

export const QUALITY_SCREENER_CONFIG: ScreenerPageConfig = {
  headerConfig: {
    title: variant.title,
    subtitle: variant.subtitle,
    description: variant.description,
  },
  pageContent: BASE_CONFIG.pageContent,
  screenerConfig: {
    scannerFields: [variant.percentileField, ...BASE_CONFIG.scannerFields],
    filtersString: `subtype_in_ADR,COMMON_SHARE,ETF;${variant.percentileField}_bt_,;marketCap_bt_25000000,`,
    limit: BASE_CONFIG.limit,
    sortField: variant.percentileField,
    sortDir: BASE_CONFIG.sortDir,
    utmPrefix: variant.utmPrefix,
  },
  tabs: createTabs('quality'),
  stockInfoRows: BASE_CONFIG.stockInfoRows,
  sections: [createRankingSection(variant), ...BASE_CONFIG.sections],
};
